import ApiService from '../../../../../../services/ApiService'
import Utils from '../../../../../../Utils/FormatDate'
import moment from 'moment'

export default {
  props: {
    serviceOrder: Object,
    hasCalled: Boolean,
  },

  created() {
    this.currentUser = JSON.parse(localStorage.getItem('user'))
    this.institution = JSON.parse(localStorage.getItem('institution'))

    if (this.serviceOrder) {
      this.currentServiceOrder = this.serviceOrder
      this.closeServiceOrderDateTime =
        this.serviceOrder.closeServiceOrderDateTime
      this.disable =
        this.institution.userType == 4 ||
        this.institution.userType == 5 ||
        this.serviceOrder.status == 1
    }
  },

  data: () => ({
    step: 0,
    selectedTab: 0,
    errorMessage: '',
    menuCloseDate: false,
    loading: false,
    firstValid: false,
    error: false,
    signatureConfirmDialog: false,
    signatureErrorDialog: false,
    closeServiceOrderDateTimeError: false,
    disable: false,
    closeDate: null,
    closeTime: null,
    closeServiceOrderDateTime: null,
    currentUser: {},
    institution: {},
    currentServiceOrder: {
      id: 0,
      ratingServiceCompleted: null,
      ratingServiceTime: null,
      closeDate: null,
      emailForEvaluation: null,
    },
    closeDateRules: [(v) => !!v || 'Data e hora requerida'],
    emailRules: [(v) => v == null || /.+@.+\..+/.test(v) || 'E-mail inválido'],
    apiService: new ApiService(),
  }),

  computed: {
    title() {
      if (this.step === 1 || (this.step == 2 && this.newSchedule)) {
        return 'Novo agendamento'
      }

      return this.currentServiceOrder.status == 0
        ? $t('Fechamento de Ordem de Serviço')
        : $t('Ordem de Serviço Fechada')
    },

    buttonText() {
      switch (this.step) {
        case 0:
          return 'Confirmar'
        default:
          return 'Terminar'
      }
    },
  },

  methods: {
    validateDates() {
      const attendDate = this.serviceOrder.dateTimeAttend
      const finalDate = this.closeServiceOrderDateTime
      let valid = true

      if (
        !!attendDate &&
        !!finalDate &&
        moment(attendDate).isAfter(moment(finalDate))
      ) {
        this.$toast.warning(
          'A data de fechamento não pode ser antes da data de atendimento'
        )
        valid = false
      }

      return valid
    },
    close() {
      if (this.step > 0) {
        this.$router.push('/serviceOrders')
      }
      this.$emit('close')
    },

    async next() {
      if (this.step === 0) {
        if (this.$refs.firstForm.validate() && this.validateDates()) {
          if (this.institution.userType != 3) {
            this.signatureConfirmDialog = true
          } else {
            this.submit()
          }
        }
      } else {
        this.close()
      }
    },

    formatDateTime(date) {
      return Utils.dateTime(date)
    },

    parseDate(date) {
      if (!date) return null

      const dateTimeSplit = date.split(' ')

      const [day, month, year] = dateTimeSplit[0].split('/')
      const time = dateTimeSplit[1]

      if (time) {
        return `${year}-${month.padStart(2, '0')}-${day.padStart(
          2,
          '0'
        )} ${time}:00`
      }

      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    formatInputDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('T')[0].split('-')
      return `${day}/${month}/${year}`
    },

    async signServiceOrder() {
      if (this.currentUser.signatureImage) {
        this.currentServiceOrder.isExecutingSigned = true
        this.currentServiceOrder.executingUserId = this.currentUser.id
        this.submit()
      } else {
        this.signatureConfirmDialog = false
        this.signatureErrorDialog = true
      }
    },

    setNowDate() {
      this.closeServiceOrderDateTime = !this.closeServiceOrderDateTime
        ? new Date()
        : this.closeServiceOrderDateTime
    },

    async submit() {
      this.loading = true

      const serviceOrder = {
        Id: this.currentServiceOrder.id,
        CloseServiceOrderDateTime: Utils.nowDatetimeFormat(
          this.closeServiceOrderDateTime
        ),
        EmailForEvaluation: this.currentServiceOrder.emailForEvaluation,
        RatingServiceCompleted: this.currentServiceOrder.ratingServiceCompleted,
        RatingServiceTime: this.currentServiceOrder.ratingServiceTime,
        isExecutingSigned: this.currentServiceOrder.isExecutingSigned,
        ExecutingUserId: this.currentServiceOrder.executingUserId,
      }

      await this.apiService
        .post('serviceOrder/closeServiceOrder', serviceOrder)
        .then(() => {
          this.step++
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })

      this.signatureConfirmDialog = false
      this.signatureErrorDialog = false
      this.loading = false
    },
  },

  watch: {
    menuCloseDate(value) {
      if (value) {
        this.selectedTab = 0
        if (this.$refs.timer) {
          this.$refs.timer.selectingHour = true
        }
      }
    },
  },
}
